<template>
  <div>
    <el-upload class="avatar-uploader" :action="ossAction" :show-file-list="false" :http-request="uploadOSSRequest">
      <img v-if="formValue && formValue != ''" :src="internalValue" class="avatar" :preview-src-list="[formValue]">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      <div v-if="tip" slot="tip" class="el-upload__tip" style="width: 440px;">
        {{ tip }}
      </div>

    </el-upload>
    <template v-if="formValue">
      <el-button @click.stop="deleteUrl" type="danger" icon="el-icon-delete" size="mini" class="delete_button"></el-button>
    </template>
  </div>
</template>

<script>
import { uploadOSSRequest, getAliyunOssToken } from "@/api/common";

export default {
  name: "activityCustomUpload",
  props: {
    formName: {
      type: String,
      default: ""
    },
    formValue: {
      type: String,
      default: ""
    },
    tip: {
      type: String,
      default: ""
    },
  },
  watch: {
    formValue(newVal) {
      if (!newVal) {
        // 清除图片显示
        this.clearImage();
      } else {
        this.internalValue = newVal;
        console.log(this.internalValue,'this.internalValue');
        
      }
      deep:true
    }

  },
  data: function () {
    return {
      ossAction: "",
      formLoading: false,
      onSubmitLoading: false,
      internalValue: this.formValue,
    }
  },
  mounted(){
    // console.log(this.formValue,'----');
  },
  methods: {
    clearImage() {
      // 清除图片显示的逻辑
      this.internalValue = '';
    },
    uploadOSSRequest (file) {
      let that = this
      this.updateLoading = true;
      console.log(file);
      
      getAliyunOssToken().then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.$emit('uploadSuccess', {
            formName: that.formName,
            fileUrl,
            file:file,
            type:'success'
          })
        });
      });
    },
    deleteUrl () {
      console.log(this.formName,'this.formName');
      
      this.$emit('uploadSuccess', {
        formName: this.formName,
        fileUrl: '',
        type:'delete'
      })
    }
  }
}
</script>
<style scoped>
.avatar-uploader {
  display: inline-block;
}

.el-button {
  position: absolute;
  bottom: 15px;
  margin-left: 10px;
}
.delete_button{
  
}
</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  min-height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 100px;
  min-height: 40px;
  display: block;
}

h1 {
  margin-bottom: 15px;
}
</style>